module.exports = __webpack_public_path__ + "img/20220327_191608.d391ba92.jpg";